import { Colors, Language, Lightning } from "@lightningjs/sdk";
import theme from "../../../lib/theme";
import { Theme, themeManager } from "../../configurations/Theme/ThemeManager";

export interface TranslatableObject {
    key: string;
    value: string | object;
}
interface TranslatableTextTemplateSpec extends Lightning.Component.TemplateSpec {
    key: string;
    backupValue: string;
    translate: TranslatableObject;
    text: object;
    skipEmpty: boolean;
}

export class TranslatableText
    extends Lightning.Component<TranslatableTextTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<TranslatableTextTemplateSpec>
{
    _skipEmpty: boolean = false;
    _backupValue: undefined | string;
    _key: undefined | string;
    _obj: undefined | TranslatableObject;

    _boundEventHandler?: any;
    private _themeCallback!: (theme: Theme | undefined) => void;

    static override _template(): Lightning.Component.Template<TranslatableTextTemplateSpec> {
        return {};
    }

    override _init() {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    private _onThemeChange(customTheme: Theme | undefined): void {
        this.patch({
            text: {
                textColor: customTheme?.title ?? Colors(theme.colors.text.primary).get()
            }
        });
    }

    set backupValue(value: string) {
        this._backupValue = value;
    }

    set key(value: string) {
        this._key = value;
        this._obj = undefined;

        this._translate();
    }

    set translate(obj: TranslatableObject) {
        this._obj = obj;
        this._key = undefined;

        this._translate();
    }

    set skipEmpty(value: boolean) {
        this._skipEmpty = value;
    }

    override _attach() {
        this._boundEventHandler = this._translate.bind(this);
        this.application.on("appLanguageChanged", this._boundEventHandler);
    }

    override _detach() {
        this.application.off("appLanguageChanged", this._boundEventHandler);
        themeManager.unsubscribe(this._themeCallback);
    }

    _translate(_self: this = this) {
        if (_self._key || _self._obj) {
            const text = _self._key
                ? Language.translate(this._key)
                : _self._obj
                  ? Language.translate(
                        _self._obj.key,
                        typeof _self._obj.value !== "object" ? { value: _self._obj.value } : _self._obj.value
                    )
                  : "";

            const key = _self._key || _self._obj?.key;
            const hasTranslation = key && text !== key;

            this.patch({
                text: {
                    text:
                        !hasTranslation && _self._backupValue
                            ? _self._backupValue
                            : !hasTranslation && _self._skipEmpty
                              ? ""
                              : text
                }
            });
        }
    }
}
